import { css } from '@styled-system/css';

interface SeparatorProps {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

export const Separator = ({ orientation = 'horizontal', className }: SeparatorProps) => {
  const separatorStyles = css({
    bg: 'border.default',
    flexShrink: 0,

    // Dimensions selon l'orientation
    ...(orientation === 'horizontal'
      ? {
          w: 'full',
          h: '1px',
        }
      : {
          w: '1px',
          h: 'full',
        }),
  });

  return <div className={`${separatorStyles} ${className || ''}`} />;
};
